import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Natural sort comparison function that handles numbers embedded in strings correctly.
 * For example: "photo-2.jpg" will come before "photo-10.jpg"
 */
export function naturalCompare(a: string, b: string): number {
  const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' })
  return collator.compare(a, b)
}
